import { ISiteBuilderState } from 'core-components/sitebuilder/store/models/ISiteBuilderState'

export const selectSiteBuilderState = (state: { siteBuilder: ISiteBuilderState }) =>
  state.siteBuilder
